import { render } from "./GameTopListCard.vue?vue&type=template&id=5b537d42&scoped=true"
import script from "./GameTopListCard.vue?vue&type=script&lang=js"
export * from "./GameTopListCard.vue?vue&type=script&lang=js"

import "./GameTopListCard.vue?vue&type=style&index=0&id=5b537d42&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b537d42"]])

export default __exports__